// copy code single product page //
function copyDiscountCode(el) {
      const code = document.getElementById("discountCode").innerText;

      // Copy to clipboard
      navigator.clipboard.writeText(code).then(() => {
        el.innerText = "COPIED!";

        // Revert back after 2 seconds
        setTimeout(() => {
          el.innerText = "COPY CODE";
        }, 2000);
      }).catch(err => {
        console.error("Failed to copy code: ", err);
      });
    }
// end copy code sigle product page//

